import { cn } from "ui";

export const TableLoader = ({ isLoading }: { isLoading: boolean }) => (
  <div
    className={cn(
      "absolute z-10 h-full w-full items-center justify-center",
      isLoading ? "bg-foundations-default/50" : "hidden"
    )}
  >
    <div className="h-1 bg-foundations-subtle">
      <div className="animate-slide flex h-full  justify-end">
        <div className="h-full w-2/3 bg-info-subtle" />
      </div>
    </div>
  </div>
);
